export default class altX {

    constructor(str) {
        this.str = str;
    }

    static checkIfAltX(event) {
        if (event !== undefined) {
            return event.altKey && event.key === "x";
        } else {
            return false;
        }
    }

    getAltx() {
        if (this.str.length > 0) {
            return altX.toCharFromChar(this.str);
        }
    }

    static toCharFromChar(content) {
        if (content.length === 1) {
            return altX.toHex(content.charCodeAt(0).toString(16).toUpperCase());
        }
        else if (content.length <= 6) {
            let bck = altX.fromHex(content);
            if (bck.trim().length > 0) {
                return bck;
            }
        }
    }

    static toHex(str) {
        let ret = str;
        if (4 - str.length > 0)
            for (var i = 4; i > str.length; i--) {
                ret = "0" + ret;
            }
        return ret;
    }

    static fromHex(str)
    {
        return String.fromCharCode(parseInt(str, 16));
    }
}


// WEBPACK FOOTER //
// ./src/scripts/kbd/AltX.js